exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps-link[data-v-17f8fb5b]{display:flex;align-items:center;flex-shrink:0;height:fit-content;margin-top:12px;margin-left:48px;margin-right:48px}.point[data-v-17f8fb5b]{width:4px;height:4px;border-radius:50%;background-color:#d4dde8}.big-point[data-v-17f8fb5b]:last-child,.point[data-v-17f8fb5b]{margin-left:13px}.big-point[data-v-17f8fb5b]{width:6px;height:6px;border-radius:50%;background-color:#d4dde8}.steps-link__pass>div[data-v-17f8fb5b]{background-color:rgba(76,110,245,.5019607843137255)}", ""]);

// exports
